import { useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../../../components/lib/modal";
import StudentRegisterStepper from "./studentRegisterStepper";
import CustomerService from "../../../../rest/customerService";
import ConfirmCloseView from "../confirmCloseView";
import NotificationsService from "../../../../rest/notificationService";

const StudentRegisterModal = ({ isOpen, setIsOpen, sendCredentials }) => {
    const [hasData, setHasData] = useState(false);
    const [confirmClose, setConfirmClose] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const requestClose = () => {
        if (hasData) {
            setConfirmClose(true);
        } else {
            setIsOpen(false);
        }
    };

    const forceClose = () => {
        setConfirmClose(false);
        setIsOpen(false);
    };

    const handleFinish = async ({ student, parents, turnIds = [] }) => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const createdStudent = await CustomerService.registerStudent(student);

            if (turnIds.length > 0 && createdStudent.login) {
                await CustomerService.updateStudentTurnPreferences(createdStudent.login, turnIds);
            }

            const parentIds = [];
            const credentials = [];

            if (createdStudent.login && createdStudent.password) {
                credentials.push({
                    id: createdStudent.id,
                    login: createdStudent.login,
                    password: createdStudent.password
                });
            }

            for (const parent of parents) {
                let finalParent = parent.data;
                if (parent.source === "NEW") {
                    const createdParent = await CustomerService.registerParent(parent.data);
                    finalParent = {
                        ...createdParent,
                        id_parent: createdParent.id
                    };

                    credentials.push({
                        id: finalParent.id_parent,
                        login: finalParent.login,
                        password: finalParent.password
                    });
                }

                const parentId = finalParent.id_parent;
                if (!parentId) throw new Error("ID do responsável não encontrado");

                parentIds.push(parentId);

                await CustomerService.addParenting(parentId, createdStudent.id);
            }

            if (sendCredentials) {
                if (credentials.length > 0 && parentIds.length > 0) {
                    await NotificationsService.sendUserCredentials(parentIds, credentials);
                }
            }

            toast.success("Cadastro efetuado com sucesso!\nCredenciais enviadas por e-mail.");

            setIsOpen(false);
        } catch (err) {
            console.error("❌ Erro no cadastro:", err);
            toast.error("Erro ao finalizar cadastro.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={requestClose}
            title="Efetuar Cadastro"
            hideFooter
        >
            <div className="relative w-full h-full flex flex-col min-h-[50vh] sm:min-h-[400px] z-90">
                <div className="flex-1 overflow-y-auto overflow-x-hidden">
                    <StudentRegisterStepper
                        onDirty={() => setHasData(true)}
                        onCancel={requestClose}
                        onFinish={handleFinish}
                        isSubmitting={isSubmitting}
                    />
                </div>

                {confirmClose && (
                    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/95 backdrop-blur-sm rounded-lg p-4 animate-in fade-in duration-200">
                        <div className="w-full max-w-sm bg-white shadow-xl rounded-xl border border-gray-200 p-1">
                            <ConfirmCloseView
                                onCancel={() => setConfirmClose(false)}
                                onConfirm={forceClose}
                            />
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default StudentRegisterModal;